// Translations
import accessKeyManagingDialog from '../components/access-key-managing-dialog/translations/tr'

// Translation: Model > Access key manager (Turkish)
export default Object.freeze({
	actions: {
		create: {
			hint: 'En fazla {{limit}} erişim anahtarı oluşturabilirsin',
			text: 'Bir erişim anahtarı oluştur'
		}
	},
	components: { accessKeyManagingDialog }
})
